<template>
    <div class="ion-padding-left ion-padding-right">
        <big-stepper :max="unboxed" size="medium" label="Items in box" v-model="plan.per_box_quantity" />
        <div class="ion-text-center">
            <ion-text color="danger" v-if="unboxed - plan.item_quantity > 0">
                {{ unboxed - plan.item_quantity }} unboxed
            </ion-text>
        </div>
    </div>
</template>

<script>
import {IonItem, IonText} from '@ionic/vue';
import BigStepper from "@/components/BigStepper";
import {computed} from "vue";

export default {
    name: "AppendBoxPlan",
    emits: ['update:modelValue'],
    props: ['modelValue', 'unboxed'],
    components: {
        BigStepper,
        IonText
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const plan = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit('update:modelValue', value);
            }
        });
        return {plan};
    },
}
</script>

<style scoped>

</style>
